//
//  src/layouts/default/contact/form/sent/Sent.js
//
import * as React from "react";
import EnquireOutcomeSent from "../../../../../components/enquire/EnquireOutcomeSent";
import "./Sent.css";

export default function FormSent() {
    return (
        <EnquireOutcomeSent
            source="form"
            subtitle="Message Received"
            message={
                <p>
                    A confirmation has been sent to your email.<br />
                    I'll get back to you personally as soon as I can.
                </p>
            }
            secondary={
                <>
                    Didn't receive a confirmation? Email me directly at{" "}
                    <a href="mailto:jeff@jefftattooer.com">jeff@jefftattooer.com</a>.
                </>
            }
        />
    );
}
